import { useServicePeriodInstances } from "./useServicePeriodInstances.js";
import { buildActiveInstanceQueryArgs } from "../queries/instance-query.js";
import { useState } from "react";
//#region src/modules/ServicePeriods/hooks/useActiveServicePeriodInstances.ts
function useActiveServicePeriodInstances(input) {
	const [nowIso] = useState(() => (/* @__PURE__ */ new Date()).toISOString());
	const fire = input.fire ?? Boolean(input.locationId || input.locationIds?.length || input.regionIds?.length);
	return useServicePeriodInstances(fire ? buildActiveInstanceQueryArgs({
		locationId: input.locationId,
		locationIds: input.locationIds,
		nowIso,
		pagination: {
			limit: 50,
			skip: 0
		},
		regionIds: input.regionIds
	}) : void 0, { fire });
}
//#endregion
export { useActiveServicePeriodInstances };

//# sourceMappingURL=useActiveServicePeriodInstances.js.map